/**
 * y轴展示浮窗扩展
 * @param chart echarts实例
 * @returns
 */
export const showYAxisExtension = (chart: any) => {
  if (chart === null || chart === undefined) return () => { };

  let elementDiv: HTMLElement | null = document.getElementById('extension');
  if (!elementDiv) {
    elementDiv = document.createElement('div');
    elementDiv.setAttribute('id', 'extension');
    elementDiv.style.display = 'block';
    const htmlDiv: HTMLElement = document.querySelector('html') as HTMLElement;
    htmlDiv.appendChild(elementDiv);
  }

  const onMouseOver = (params: { componentType: string; value: string; }) => {
    if (params.componentType === 'yAxis') {
      const elementDiv: HTMLElement = document.querySelector('#extension') as HTMLElement;
      elementDiv.style.cssText =
        'position: absolute; z-index: 99999; color: #fff; font-size: 14px; padding: 5px; display: inline; border-radius: 4px; background-color: #303133; box-shadow: rgba(0, 0, 0, 0.3) 2px 2px 8px';
      elementDiv.innerHTML = `${params?.value}`;
      const htmlDiv: HTMLElement = document.querySelector('html') as HTMLElement;
      htmlDiv.onmousemove = onMouseMove;
    }
  };

  const onMouseMove = (event: MouseEvent) => {
    const elementDiv: HTMLElement = document.querySelector('#extension') as HTMLElement;
    const xx = event.pageX - 10;
    const yy = event.pageY + 15;
    elementDiv.style.top = `${yy}px`;
    elementDiv.style.left = `${xx}px`;
  };

  const onMouseOut = (params: any) => {
    if (params.componentType === 'yAxis') {
      const elementDiv: HTMLElement = document.querySelector('#extension') as HTMLElement;
      elementDiv.style.cssText = 'display:none';
      const htmlDiv: HTMLElement = document.querySelector('html') as HTMLElement;
      htmlDiv.onmousemove = null; // 移除 onmousemove 事件
    }
  };

  chart.on('mouseover', onMouseOver);
  chart.on('mouseout', onMouseOut);

  // 返回一个销毁函数，用于移除事件监听和删除 extension 元素
  return () => {
    chart.off('mouseover', onMouseOver);
    chart.off('mouseout', onMouseOut);
    const htmlDiv: HTMLElement = document.querySelector('html') as HTMLElement;
    htmlDiv.onmousemove = null; // 确保移除 onmousemove 事件

    // 移除 extension 元素
    if (elementDiv) {
      elementDiv.remove();
      elementDiv = null; // 确保引用被清空
    }
  };
};